import { adaptCoordinates } from "./adaptCoordinates";
export var getCenter = function getCenter(centerFromBounds, latitude, longitude) {
  return centerFromBounds || adaptCoordinates(latitude, longitude);
};